export const REGISTERED_USER_EVENT = 'user-registered';

export interface RegisteredUserEventData {
  customerTypeId: number | null;
  event: typeof REGISTERED_USER_EVENT;
  registeredUserId: string;
  registrationChannel: string;
  registrationType: string;
  sponsorNumber: string;
  signUpDate: string;
  visitorSegment: number;
}
